import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { LegacyDashboardApiAdapter } from '../adapters/LegacyDashboardApiAdapter';

export function useLegacyDashboard() {
  const adapter = useMemo(() => new LegacyDashboardApiAdapter(createHttpClient(apiClientWH)), []);

  return useQuery({
    queryKey: ['legacy-dashboard'],
    queryFn: () => adapter.getDashboard(),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: (failureCount, error: unknown) => {
      const msg = error instanceof Error ? error.message : String(error);
      if (msg.includes('401') || msg.includes('403')) return false;
      return failureCount < 2;
    },
  });
}
